import React from 'react';
export function SectionImage2() {
  return <section className="w-full" data-id="element-116">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772490429/hf_20260302_222348_cb12784a-1a3a-4ca3-a606-216afc6ed502_ifdlkp.jpg" alt="Sección promocional 2" className="w-full block" style={{
      display: 'block'
    }} data-id="element-117" />
    </section>;
}